import type { SafeAreaInsets, TelegramUser } from './TelegramAdapter';

const MOCK_USER: TelegramUser = {
  id: 12345678,
  first_name: 'Тестовый',
  last_name: 'Хомяк',
  username: 'test_hamster',
  language_code: 'ru',
  is_premium: false,
};

export class MockTelegramAdapter {
  private isTelegram = false;
  private _isFullscreen = false;
  private callbacks: Array<() => void> = [];

  getIsTelegram(): boolean {
    return this.isTelegram;
  }

  getInitData(): string {
    return 'mock_init_data_for_testing';
  }

  getUser(): TelegramUser {
    return MOCK_USER;
  }

  getSafeAreaInsets(): SafeAreaInsets {
    return { top: 0, bottom: 0, left: 0, right: 0 };
  }

  getContentSafeAreaInsets(): SafeAreaInsets {
    return { top: 0, bottom: 0, left: 0, right: 0 };
  }

  getHeaderHeight(): number {
    return 0;
  }

  getViewportHeight(): number {
    return window.innerHeight;
  }

  getViewportWidth(): number {
    return window.innerWidth;
  }

  colorScheme(): 'light' | 'dark' {
    return 'dark';
  }

  onThemeChanged(callback: (scheme: 'light' | 'dark') => void): void {
    this.callbacks.push(() => callback(this.colorScheme()));
  }

  disableVerticalSwipe(): void {}

  close(): void {}

  // Fullscreen
  async requestFullscreen(): Promise<boolean> {
    try {
      const el = document.documentElement;
      if (el.requestFullscreen) {
        await el.requestFullscreen();
        this._isFullscreen = true;
        return true;
      }
      const safariEl = el as HTMLElement & { webkitRequestFullscreen?: () => void };
      if (safariEl.webkitRequestFullscreen) {
        safariEl.webkitRequestFullscreen();
        this._isFullscreen = true;
        return true;
      }
    } catch { /* fall through */ }
    return false;
  }

  exitFullscreen(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen?.();
    }
    this._isFullscreen = false;
  }

  isFullscreen(): boolean {
    return this._isFullscreen || !!document.fullscreenElement;
  }

  onFullscreenChange(callback: (isFullscreen: boolean) => void): void {
    const handler = () => callback(this.isFullscreen());
    document.addEventListener('fullscreenchange', handler);
    document.addEventListener('webkitfullscreenchange', handler);
  }

  // Orientation
  lockOrientation(): boolean {
    try {
      const orient = screen.orientation as ScreenOrientation & { lock?: (o: string) => Promise<void> };
      if (orient.lock) {
        orient.lock('any');
        return true;
      }
    } catch { /* noop */ }
    return false;
  }

  unlockOrientation(): void {
    try {
      const orient = screen.orientation as ScreenOrientation & { unlock?: () => void };
      orient.unlock?.();
    } catch { /* noop */ }
  }

  getOrientation(): 'portrait' | 'landscape' {
    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait';
  }

  onOrientationChange(callback: (orientation: 'portrait' | 'landscape') => void): void {
    window.addEventListener('orientationchange', () => {
      setTimeout(() => callback(this.getOrientation()), 150);
    });
  }

  emitReady(): void {
    for (const cb of this.callbacks) {
      cb();
    }
  }
}
